import { useEffect, useRef, useState } from "react";
import { Box, Button } from "@mui/material";
import * as pdfjs from "pdfjs-dist";
import workerSrc from "pdfjs-dist/build/pdf.worker?url"; // Import local worker
import { useDispatch, useSelector } from "react-redux";
import { toggleFullView } from "../../store/reducers/uploadDocumentSlice";
import { useOutletContext, useNavigate } from "react-router-dom";
import { esignIcons } from "./icons";
import { esignToolApi } from "../../services/esignApi";
import { setSigners } from "../../store/reducers/signerSlice";

pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;

const PDFPreview = ({ pdfUrl, onDelete, onFullView }) => {
  const canvasRef = useRef(null);
  const boxRef = useRef(null);
  const dispatch = useDispatch();
  const { setOpenSideBar, openSideBar } = useOutletContext();
  const navigate = useNavigate();
  const { uploadedDocument} = useSelector((state) => state.uploadDocument);
  const { signers } = useSelector((state) => state.signers);
  console.log(uploadedDocument)
  
  useEffect(() => {
    console.log(pdfUrl)
    if (!pdfUrl) return;

    const loadPdf = async () => {
      try {
        const pdf = await pdfjs.getDocument(pdfUrl).promise;
        const page = await pdf.getPage(1);

        const box = boxRef.current;
        if (!box) return;

        const boxWidth = box.clientWidth;
        const boxHeight = box.clientHeight;

        const scale = 20;
        const pixelRatio = window.devicePixelRatio || 1;
        const viewport = page.getViewport({ scale });

        // Fit the PDF into the box while maintaining aspect ratio
        const scaleX = (boxWidth * pixelRatio) / viewport.width;
        const scaleY = (boxHeight * pixelRatio) / viewport.height;
        const finalScale = Math.min(scaleX, scaleY) * 30; // Increase for sharper text

        const highResViewport = page.getViewport({ scale: finalScale });

        const canvas = canvasRef.current;
        const context = canvas.getContext("2d");

        // Set high-resolution canvas size
        canvas.width = highResViewport.width;
        canvas.height = highResViewport.height;

        // Scale down using CSS for better rendering
        canvas.style.width = `${boxWidth}px`;
        canvas.style.height = `${boxHeight}px`;

        // Enable anti-aliasing for sharper text
        context.imageSmoothingEnabled = true;
        context.imageSmoothingQuality = "high";

        const renderContext = {
          canvasContext: context,
          viewport: highResViewport,
        };

        await page.render(renderContext).promise;
      } catch (error) {
        console.error("Error loading PDF:", error);
      }
    };

    loadPdf();
  }, [pdfUrl]);

  useEffect(() => {
      if (uploadedDocument?.data?.document_id) {
          fetchSignersData(uploadedDocument?.data?.document_id);
      }
  }, [uploadedDocument?.data?.document_id]);

  const fetchSignersData = async (documentID) => {
    try {
        const response = await esignToolApi.fetchManualSigner(documentID);
        if (response) {
            dispatch(setSigners(response)); 
        }
    } catch (error) {
        console.error("Error fetching signers:", error);
        if (error?.response?.data?.message == "No signers found") {
            dispatch(setSigners([])); 
        }
    }
  };

    return (
        <Box
        ref={boxRef}
        sx={{
            width: "320px",
            height: "480px",
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
            backgroundColor: "#f5f5f5",
            boxShadow: "rgba(0, 0, 0, 0.05) 0px 2px 33px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 0px",
            borderRadius: "24px",
            m: "auto",
        }}
        >
        <canvas ref={canvasRef} style={{ width: "320px" }} />
        <Box className="overlay" sx={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0, 0, 0, 0.6)", opacity: 0, transition: "opacity 0.3s ease-in-out", opacity: 0.4, }} />

        {signers.length > 0 && (
            <Box sx={{ position: "absolute", bottom: 10, left: 0, width: "100%", display: "flex", justifyContent: "space-evenly", }} >
                {/* <Button variant="contained" onClick={onDelete} 
                    sx={{ 
                        width: "140px",
                        height: "48px",
                        border: "1px solid #FFFFFF33",
                        fontSize: "16px",
                        fontWeight: 500,
                        color: "#FFFFFF",
                        background: "#FFFFFF4D",
                        background: "rgba(255, 255, 255, 0.3)",
                        border: "1px solid rgba(255, 255, 255, 0.2)",
                        backdropFilter: "blur(20px)",
                        borderRadius: "12px",
                        textTransform: "none",
                        display: "flex",
                        justifyContent: "space-evenly",
                        padding: "6px 5px",
                    }}
                >
                    {esignIcons.deleteMinusIcon}Delete
                </Button> */}
                <Button variant="contained" onClick={() => {dispatch(toggleFullView()); setOpenSideBar(!openSideBar); navigate("/esign/pdfeditor", { replace: true }); }} 
                    sx={{ 
                        width: "288px",
                        height: "48px",
                        border: "1px solid #FFFFFF33",
                        fontSize: "16px",
                        fontWeight: 500,
                        color: "#FFFFFF",
                        background: "#FFFFFF4D",
                        background: "rgba(255, 255, 255, 0.3)",
                        border: "1px solid rgba(255, 255, 255, 0.2)",
                        backdropFilter: "blur(20px)",
                        borderRadius: "12px",
                        textTransform: "none",
                        display: "flex",
                        justifyContent: "center",
                        padding: "6px 5px",
                        gap: "16px",
                    }} 
                >
                   {esignIcons.fullviewIcon}Full View
                </Button>
            </Box>
        )}
        </Box>
    );
};

export default PDFPreview;
